<!--CONFLICT: entire html content from phase2 is selected to resolve conflict. Check at development branch if something is missing.
  Translations from development branch applied manually-->
<div class="col p-0">
  <div class="wardSelectInstitution">
    <div class="institution-name">
      <!-- <img src="assets/img/menuActive/Institution.svg" alt="Institution"> (click)="openmodal(templateInstitution)"-->
      <p class="m-0 selectedInsText cursor" *ngIf='showInstitutionDropDown()'>
        {{selectedInstitution | labelSanitizer}}
        <!-- <a class="menuLink tooltipEvalution">
                <img src="assets/img/svg/icon-change.svg">
                <span class="tooltiptext">{{'LAYOUT_MODULE.CHANGE_INSTITUTION' | translate}}</span>
            </a>  -->
      </p>
      <p class="m-0" *ngIf='!showInstitutionDropDown()'>{{getInstitutionName() | labelSanitizer}}</p>
    </div>
  </div>
  <form [formGroup]="settingsFormGroup" #ngForm="ngForm">
    <h5 class="section-head my-4 panton-bold" *ngIf="isObserveLicense(packageID)">{{
      translationKeys.LayoutModule.Observe |
      translate }}
    </h5>
    <div *ngIf="isObserveLicense(packageID)">
      <div class="row">
        <div class="col-md-4 col-sm-12 p-0">
          <div class="switch-container p-0 form-group">
            <label for="recordingAseptic">
              <div class="section-title roboto-black bold">{{'CONFIGURE.RECORDING_ASEPTIC_TASKS_1' |
                translate }}</div>
              <div class="roboto pt-2">{{'CONFIGURE.SHOW_RECORDING_ASEPTIC_TASKS' | translate }}</div>
            </label>
            <label class="switch mb-4 mt-2 d-block">
              <mat-slide-toggle color="primary" name="recordingAseptic" formControlName="recordingAseptic" [id]="'recording-aseptic-slider'">
                <span *ngIf="settingsFormGroup.get('recordingAseptic').value">{{'CONFIGURE.ENABLED' |
                  translate}}</span>
                <span *ngIf="!settingsFormGroup.get('recordingAseptic').value">{{"CONFIGURE.DISABLED" |
                  translate }}</span>
              </mat-slide-toggle>

            </label>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 p-0">
          <div class="switch-container p-0 form-group">
            <label for="recordingAseptic">
              <div class="section-title roboto-black bold">{{'OBSERVATION.HANDWASH' | translate }}</div>
              <div class="roboto pt-2">{{'CONFIGURE.SHOW_HANDWASH' | translate }}</div>
            </label>
            <label class="switch mb-4 mt-2 d-block">
              <mat-slide-toggle color="primary" name="enableHandWashing" formControlName="enableHandWashing" [id]="'enable-handwash-slider'">
                <span *ngIf="settingsFormGroup.get('enableHandWashing').value">{{'CONFIGURE.ENABLED' |
                  translate}}</span>
                <span *ngIf="!settingsFormGroup.get('enableHandWashing').value">{{"CONFIGURE.DISABLED" |
                  translate }}</span>
              </mat-slide-toggle>
            </label>
          </div>
        </div>
      </div>

    </div>
    <h5 class="section-head my-4 panton-bold" *ngIf="isMyHygieneSOPLicense(packageID)">{{'EVALUATION.MY_HYGIENE_SOP' | translate }}
    </h5>
    <div *ngIf="isMyHygieneSOPLicense(packageID)">
      <div class="row">
        <div class="col-md-4 col-sm-12 p-0">
          <div class="switch-container p-0 form-group">
            <label for="noSterility">
              <div class="section-title roboto-black bold">{{'SOP_OBSERVATION.NO_STERILITY' | translate }}
              </div>
              <div class="roboto bold hide-text">-</div>
            </label>
            <label class="switch mb-4 mt-2 d-block">
              <mat-slide-toggle color="primary" name="noSterility" formControlName="noSterility" [id]="'no-sterility'">
                <span *ngIf="settingsFormGroup.get('noSterility').value">{{'CONFIGURE.ENABLED' |
                  translate}}</span>
                <span *ngIf="!settingsFormGroup.get('noSterility').value">{{"CONFIGURE.DISABLED" | translate
                  }}</span>
              </mat-slide-toggle>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="consumptionSectionTitle pt-4" *ngIf="isDisabledState">
      <h5 class="section-head panton-bold">{{'CONFIGURE.CONSUMPTION' | translate }} {{currentYear}}</h5>
      <label class="sectionTitleLabel roboto">{{translationKeys.Configure.ConsumptionConfMessage | translate }}
        {{currentYear}}</label>
    </div>
    <div class="pt-3" *ngIf="isDisabledState">
      <div class="row">
        <div class="col-md-4 col-sm-12 p-0">
          <label class="roboto-label">{{'CONFIGURE.PERIOD_1' | translate }}</label>
          <div>
            <div [ngSwitch]="settingsFormGroup.value.period">
              <span class="section-title" *ngSwitchCase="'m'">{{'CONFIGURE.MONTH' | translate
                }}</span>
              <span class="section-title" *ngSwitchCase="'q'">{{'CONFIGURE.QUARTER' | translate
                }}</span>
              <span class="section-title" *ngSwitchCase="'y'">{{'CONFIGURE.YEAR' | translate }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 p-0">
          <div class="form-group">
            <label class="roboto-label">{{'CONFIGURE.CONSUMPTION_MEASURED_IN' | translate }}</label>
            <div>
              <div [ngSwitch]="settingsFormGroup.value.amountMeasured">
                <span class="section-title" *ngSwitchCase="'u'">{{'CONFIGURE.USED_PRODUCT_1' | translate
                  }}</span>
                <span class="section-title" *ngSwitchCase="'p'">{{'CONFIGURE.PURCHASED_OR_DISTRIBUTED_PRODUCT_1'
                  | translate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 p-0">
          <div class="form-group">
            <label class="roboto-label">{{'CONFIGURE.MEASUREMENT_UNIT' | translate }}</label>
            <div>
              <div [ngSwitch]="settingsFormGroup.value.unitMeasured">
                <span class="section-title" *ngSwitchCase="'m'">{{'CONFIGURE.MILLILITRE' | translate
                  }}</span>
                <span class="section-title" *ngSwitchCase="'l'">{{'CONFIGURE.LITER' | translate
                  }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="consumptionSectionTitle pt-4">
      <h5 class="section-head panton-bold">{{'CONFIGURE.CONSUMPTION' | translate }} {{nextYear}}</h5>
      <label class="sectionTitleLabel roboto" *ngIf="isDisabledState">{{
        translationKeys.Configure.ConsumptionConfNext |
        translate }} {{nextYear}}</label>
    </div>
    <div class="pt-3">
      <div class="row">
        <div class="col-md-4 col-sm-12 p-0">
          <div class="form-group">
            <label class="roboto-label-big">{{'CONFIGURE.PERIOD_1' | translate }}</label><span
              class="mandatory">*</span>
            <div>
              <div class="mb-2 form-check">
                <input type="radio" formControlName="nextPeriod" value="m" name="nextPeriod" class="form-check-input"
                  [checked]="settingsFormGroup.value.nextPeriod=='m'" id="periodMonth">
                <label class="form-check-label" for="periodMonth">{{'CONFIGURE.MONTH' | translate
                  }}</label>
              </div>
              <div class="mb-2 form-check">
                <input type="radio" formControlName="nextPeriod" value="q" name="nextPeriod" class="form-check-input"
                  [checked]="settingsFormGroup.value.nextPeriod=='q'" id="periodQuarter">
                <label class="form-check-label" for="periodQuarter">{{'CONFIGURE.QUARTER' | translate
                  }}</label>
              </div>
              <div class="mb-2 form-check">
                <input type="radio" formControlName="nextPeriod" value="y"
                  [checked]="settingsFormGroup.value.nextPeriod=='y'" name="nextPeriod" class="form-check-input"
                  id="periodYear">
                <label class="form-check-label" for="periodYear">{{'CONFIGURE.YEAR' | translate
                  }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 p-0">
          <div class="form-group">
            <label class="roboto-label-big">{{'CONFIGURE.CONSUMPTION_MEASURED_IN' | translate
              }}</label><span class="mandatory">*</span>
            <div>
              <div class="mb-2 form-check">
                <input type="radio" formControlName="nextAmountMeasured" value="u" name="nextAmountMeasured"
                  [checked]="settingsFormGroup.value.nextAmountMeasured=='u'" class="form-check-input"
                  id="amountMeasured1">
                <label class="form-check-label" for="amountMeasured1">{{'CONFIGURE.USED_PRODUCT_1' |
                  translate
                  }}</label>
              </div>
              <div class="mb-2 form-check">
                <input type="radio" formControlName="nextAmountMeasured" value="p" name="nextAmountMeasured"
                  [checked]="settingsFormGroup.value.nextAmountMeasured=='p'" class="form-check-input"
                  id="amountMeasured2">
                <label class="form-check-label" for="amountMeasured2">{{'CONFIGURE.PURCHASED_OR_DISTRIBUTED_PRODUCT_1' |
                  translate
                  }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 p-0">
          <div class="form-group">
            <label class="roboto-label-big">{{'CONFIGURE.MEASUREMENT_UNIT' | translate }}</label><span
              class="mandatory">*</span>
            <div>
              <div class="mb-2 form-check">
                <input type="radio" formControlName="nextUnitMeasured" value="m" name="nextUnitMeasured"
                  [checked]="settingsFormGroup.value.nextUnitMeasured=='m'" class="form-check-input" id="unitMeasured1">
                <label class="form-check-label" for="unitMeasured1">{{'CONFIGURE.MILLILITRE' | translate
                  }}</label>
              </div>
              <div class="mb-2 form-check">
                <input type="radio" formControlName="nextUnitMeasured" value="l" name="nextUnitMeasured"
                  [checked]="settingsFormGroup.value.nextUnitMeasured=='l'" class="form-check-input" id="unitMeasured2">
                <label class="form-check-label" for="unitMeasured2">{{'CONFIGURE.LITER' | translate
                  }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <h5 class="section-head my-4 panton-bold">{{translationKeys.Configure.HaiSettings | translate }}</h5>
    <div>
      <div class="row">
        <div class="switch-container p-0 form-group">
          <label for="enableHAITracking">
            <div class="section-title roboto-black bold">{{'CONFIGURE.HAI_TRACKING' | translate }}</div>
          </label>
          <label class="switch mb-4 mt-2 d-block">
            <mat-slide-toggle [id]="'enable-hai-tracking-slider'" color="primary" name="enableHAITracking" formControlName="enableHAITracking">
              <span *ngIf="settingsFormGroup.get('enableHAITracking').value">{{'CONFIGURE.ENABLED' |
                translate}}</span>
              <span *ngIf="!settingsFormGroup.get('enableHAITracking').value">{{"CONFIGURE.DISABLED" |
                translate }}</span>
            </mat-slide-toggle>
          </label>
        </div>
      </div>
    </div>
    <h5 class="section-head my-4 panton-bold">{{'CONFIGURE.MY_HYGIENE_SOP_SETTINGS' | translate }}</h5>
    <div class="">
      <div class="row">
        <div class="switch-container p-0 form-group">
          <label for="professionalSubcategory">
            <div class="section-title roboto-black bold">{{'CONFIGURE.PROFESSIONAL_SUBCATEGORY' | translate
              }}</div>
            <div class="roboto bold">{{'CONFIGURE.SHOW_PROFESSIONAL_SUBCATEGORY' | translate }}</div>
          </label>
          <label class="switch mb-4 mt-2 d-block">

            <mat-slide-toggle [id]="'professional-subcategory-slider'" color="primary" name="professionalSubcategory" formControlName="professionalSubcategory">
              <span *ngIf="settingsFormGroup.get('professionalSubcategory').value">{{'CONFIGURE.ENABLED' |
                translate}}</span>
              <span *ngIf="!settingsFormGroup.get('professionalSubcategory').value">{{"CONFIGURE.DISABLED"
                | translate }}</span>
            </mat-slide-toggle>

          </label>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <button (click)="saveSettings()" [id]="'save-update-button'" class="btn btn-continue-bordered-bd mr-4">{{ ((generalSettingID ==
        0)?translationKeys.Authorization.Save: translationKeys.Observation.Update ) | translate }}</button>
    </div>

  </form>
</div>

<ng-template #templateInstitution>
  <div class="modal-header justify-content-between align-items-center">
    <h5 class="modal-title" id="exampleModalLabel">{{ translationKeys.UserProfiles.SelectInsititutions | translate}}
    </h5>
    <a class="cursor" aria-label="Close" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="modal-body" data-simplebar class="change-lang">
    <div [formGroup]="myInstitutions" class="col-12">
      <div class="mb-2 form-check" *ngFor='let Institutions of InstitutionsList;let i = index'>
        <input type="radio" [value]="Institutions.institution.institutionID" name="selectedIns"
          *ngIf="showInstitutionDropDown()" formControlName="selectedIns" class="form-check-input"
          id={{Institutions.institution.institutionID}}>
        <label class="form-check-label"
          for={{Institutions.institution.institutionID}}>{{Institutions.institution.institutionName}}</label>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-6 my-3">
          <button type="button" class="btn btn-continue-bordered-bd"
            (click)="onInstitutionChange(myInstitutions.value.selectedIns);modalRef.hide();">{{
            translationKeys.Authorization.Done | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
